module.exports = __webpack_public_path__ + "static/media/PersonasJuridicas.d31e9c51.png";